/*
These functions make sure WordPress
and Foundation play nice together.
*/
var window = jQuery(window);
jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
	jQuery('.main .grid-x_wrapper').removeClass('grid-x_wrapper').find('.gform_body .gform_fields').addClass("grid-x grid-padding-x");
	jQuery('.main .gfield.hidden_label .gfield_label').remove();
	// jQuery('.main .gform_footer').addClass('cell small-12 medium-auto'); 	

	jQuery('#additional-footer .grid-x_wrapper').removeClass('grid-x_wrapper').find('.gform_body').addClass("cell small-12 medium-9");
	jQuery('#additional-footer .gfield.hidden_label .gfield_label').remove();
	jQuery('#additional-footer .gform_footer').addClass('cell small-12 medium-auto'); 
	jQuery('.featuredPage.cell .button.white').hover( function() {
		//console.log('hovered that stuff');
		jQuery(this).children('.excerpt-content').toggleClass('fadeInUp').toggleClass('fadeOutDown');
	});
/*
	if (jQuery('body').hasClass('home')){ 
		navCheck(); 
	}
*/
	swatch();
	debugin();
	
	initHpVideo();
	initCheckVideo();
	
	addGridX();
	
	initParallax();
	rSlider();
	credSlider();
	initNavigation();
	initSubmenus();
	initCopyButton();
	jQuery('.home .button.hover-activate').on('hover', function(){
		jQuery(this).closest('.featuredPageInner').toggleClass('hoveredBG');
	});
});


function addGridX() {
	// Find the <ul> element with ID "gform_fields_2" and add the class "grid-x" to it
	jQuery('#gform_fields_2').addClass('grid-x');
}

function initSubmenus() {
	jQuery('#menu-topnav-1').css('opacity',1);		
}


function initNavigation() {
	jQuery('.sticky-wrapper-navigation').on('sticky.zf.stuckto:top', function(){
	  	jQuery(this).addClass('shrink');
	}).on('sticky.zf.unstuckfrom:top', function(){
	  	jQuery(this).removeClass('shrink');
	})
}

function rSlider() {
	jQuery('#rSlider').flickity({
		pageDots: true,
		wrapAround: true,
		cellSelector: '.rslide',
		draggable: true,
		autoPlay: 6000,
	});
}

function credSlider() {
	jQuery('#credsSlider').flickity({
		pageDots: false,
		wrapAround: true,
		cellSelector: '.credslide',
		draggable: true,
		prevNextButtons: false,
		container: true,
		autoPlay: true,
	});
}



function initParallax(){	
	// Use the class name 'parallax', use data-speed="0.2"(20% scroll rate use decimals)
	
    jQuery(window).on('load scroll', function () {
        var scrolled =  jQuery(this).scrollTop();
        jQuery('.tagline').css({
            'transform': 'translate3d(0, ' + -(scrolled * 0.25) + 'px, 0)', 
            'opacity': 1 - scrolled / 400 // fade out at 400px from top
        });
        
                
        jQuery('.banner-parallax').each(function(){ 
	        	var speed = jQuery(this).attr('data-speed');
	        	var position = jQuery(this).parent().position();			
	        	jQuery(this).css('transform', 'translate3d(0, ' + ((scrolled - position.top) * speed) + 'px, 0)');        	
        });
        
        jQuery('.parallax').each(function(){ 
	        	var speed = jQuery(this).attr('data-speed');
	        	var parent = jQuery(this).parent();
	        	var parentHeight = parent.height();
	        	var position = parent.position();
	        	
	        	if(!speed){ speed = 0.2; }
	        	
	        	parent.css('overflow','hidden');
	        	parent.css('position','relative');
	        				
	        	jQuery(this).css('transform', 'translate3d(0, ' + ((scrolled - position.top) * speed) + 'px, 0)');        	
        });
        
        
    });	    
}


// builds color swatches for style guide
function rgb2hex(rgb) {
    rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    function hex(x) {
        return ("0" + parseInt(x).toString(16)).slice(-2);
    }
    return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
}

function swatch() {
	var swatchcolor = '#eee';
	var swatchbgc ="rgb(238,238,238)";
	var swatchhex = '#eee';
	var swatchTxt = '';
	var swatchInfo = '';
	var yus = [
		'primary',
		'secondary',
		'warning',
		'success',
		'alert',
	];
	jQuery('.swatch-block') .each(function(sw){
		swatchcolor = jQuery(this).attr("data-swatch");
		//console.log(swatchcolor);
		if ( 
			swatchcolor === 'primary' || 
			swatchcolor === 'secondary' || 
			swatchcolor === 'success' || 
			swatchcolor === 'warning' || 
			swatchcolor === 'alert'
			) {
			jQuery(this).wrapInner('<div class="cell auto swatch-info ">','</div>');
			jQuery('<div class="cell swatch"></div>').prependTo(this);
			jQuery(this).find('.swatch').addClass(swatchcolor+'-swatch');
			swatchbgc = jQuery(this).find('.swatch').css('background-color');
			swatchhex = rgb2hex(swatchbgc);
			swatchTxt = jQuery('<span>' + swatchhex + '</span>');
			swatchInfo = jQuery(this).find('.swatch-info');
			jQuery(swatchTxt).prependTo(swatchInfo);
			jQuery(this).wrapInner('<div class="grid-x grid-margin-x">','</div>');			
		} else {
			jQuery('<span>' + swatchcolor + '</span>').prependTo(this).children('p');
			jQuery(this).wrapInner('<div class="cell auto swatch-info ">','</div>');
			jQuery('<div class="cell swatch" style="background-color: ' + swatchcolor +';"></div>').prependTo(this);
			jQuery(this).wrapInner('<div class="grid-x grid-margin-x">','</div>');			
		}
	});

}
var navigator;
var DocumentTouch;
// VIDEO FOR FRONT PAGE
function initHpVideo() {		
			var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		
	jQuery('.banner-wrapper .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false; 
		
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".banner-wrapper .video").addClass("mobile");
			jQuery(".banner-wrapper .video").removeClass("desktop");
		} else {
			jQuery(".banner-wrapper .video").addClass("desktop");
		}
	});
}

function initCheckVideo(){
var vid = document.getElementById("fpVideo");

	if (vid) {
		vid.onloadedmetadata = function() {   
		    jQuery('.loader').fadeOut('slow');
		};
	}
}
// used to console log screen breakpoint changes while developing themes
function debugin() {
	var currentBreakpoint = Foundation.MediaQuery.current;
	console.log('the current breakpoint is ' + currentBreakpoint);
	jQuery(window).resize(function() {
		var currentBreakpoint = Foundation.MediaQuery.current;
		console.log('the current breakpoint is ' + currentBreakpoint);
		if(currentBreakpoint == 'small' || currentBreakpoint == 'smedium'){
			jQuery('.specialtySlide').addClass('fadeIn').removeClass('fadeOut');
		}
	});
}

function initCopyButton() {
	
	jQuery('.share-buttons-container').parent().addClass('no-padding no-box-shadow');
	
	jQuery('.copy-button').on('click', function() {
		jQuery(this).append("<input></input>");
		jQuery(this).css('pointer-events', 'none');
		
		jQuery(this).find('input').val(window.location.href).select();
		document.execCommand("copy");
		
		if(jQuery(this).find('.link-notify').length < 1) {
			jQuery(this).append("<p class='text-center link-notify'>Link has been copied</p>");
		}
		
		jQuery(this).find('input').remove();
		jQuery(this).css('pointer-events', 'auto');
	})
}